// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2zQWG","label":"Labeled_label__2JU7c","divider":"Labeled_divider__1Oz6F"};